import type { IBrandConfig } from './types';

const ENGUARD_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'external', url: 'https://enguard.io/privacy-policy' },
  termsOfService: {
    kind: 'external',
    url: 'https://enguard.io/terms-of-service',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'enguard',
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: 'https://app.enguard.io',
  carouselBanners: false,
  missingPII: true,
  security: false,
  billingDetails: false,
  finishSetup: false,
  secureUpload: true,
  accountDetails: true,
  adaChat: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default ENGUARD_BRAND_CONFIG;
